import {NgModule} from '@angular/core';
import {WeHaveBeenInTheNewsComponent} from './we-have-been-in-the-news.component';
import {CommonModule} from '@angular/common';

@NgModule({
    declarations: [WeHaveBeenInTheNewsComponent],
    imports: [
        CommonModule
    ],
    exports: [WeHaveBeenInTheNewsComponent]
})
export class WeHaveBeenInTheNewsModule {
}
